<template>
	<v-dialog v-model="dialog" width="500">
		<v-card>
			<v-container>
				<v-row>
					<v-col>
						<s-textarea label="Motivo" v-model="TskReasonTraslate"></s-textarea>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<v-btn color="primary" @click="sendPaused">
							{{ task.TskPaused == 0 ? "Pausar" : "Reanudar" }}
						</v-btn>
					</v-col>
					<v-col>
						<v-btn color="warning" @click="cancelPausedTask">
							Cancelar
						</v-btn>
					</v-col>
				</v-row>
			</v-container>
		</v-card>
	</v-dialog>
</template>

<script>
import _sTaskService from '@/services/InformationTechnology/TaskService.js';
import sTextarea from '../../../components/Utils/sTextarea.vue'; 

export default {
    name: 'TaskPauseModal',
    components: {
        sTextarea
    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        task: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            TskReasonTraslate: ""
        };
    },
    computed: {
        dialog: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        }
    },
    watch: {
        dialog(val) {
            if (val) {
                this.TskReasonTraslate = "";
            }
        }
    },
    methods: {
        cancelPausedTask() {
            this.dialog = false;
        },
        sendPaused() {
			if (!this.task || !this.task.TskID) return;

			let updatedTask = { ...this.task };
			updatedTask.TskStatus = 103;
			updatedTask.UsrUpdateID = this.$fun.getUserID();
			updatedTask.TskReasonTraslate = this.TskReasonTraslate;
			
            this.$fun.alert("¿Seguro de pausar?", "question")
				.then(r => {
					if (r.value) {
						_sTaskService.save(updatedTask, this.$fun.getUserID())
							.then(resp => {
								if (resp && resp.status == 200) {
									this.$fun.alert("Pausado correctamente", "success");
									this.$emit('paused');
									this.dialog = false;
								}
							});
					}
				});
		}
    }
};
</script>
